module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Kienberg_SO-3a68b75b4125ebceb7121c5a12facdc2.svg";